import React, { useContext } from 'react';
import { P as PropTypes } from './index-097535f1.js';
var r = new Map();

function a(t) {
  return r.has(t) || r.set(t, React.createContext({
    inside: !1,
    data: null
  })), r.get(t);
}

function i(_ref) {
  var t = _ref.children,
      n = _ref.data,
      r = _ref.name;
  var i = a(r);
  return React.createElement(i.Provider, {
    value: {
      inside: !0,
      data: n
    }
  }, t);
}

function o(e) {
  var _useContext = useContext(a(e)),
      n = _useContext.inside,
      r = _useContext.data;

  return [n, r];
}

i.propTypes = {
  children: PropTypes.node,
  data: PropTypes.any,
  name: PropTypes.string.isRequired
};
export { i, o };